









































































































































































































import { apiService, AppConstants, Interfaces, Models, Utils } from "@/core/Export";
import store from "@/store";
import { Component, Vue, Watch } from "vue-property-decorator";
@Component({
  components: {},
})
export default class EmployeeAttendEditMobile extends Vue {
  employeeAttendDayEditData: Models.EAME_DayDto;
  isEmployeeAttendDayEditDataReady: boolean;
  permissions: any;
  notSignReasonsLocal: any;
  attendSpecialEventsLocal: any;

  constructor() {
    super();
    this.employeeAttendDayEditData = new Models.EAME_DayDto();
    this.isEmployeeAttendDayEditDataReady = false;
    this.permissions = AppConstants.Permissions;
    this.notSignReasonsLocal = this.notSignReasons;
    this.attendSpecialEventsLocal = this.attendSpecialEvents;

  }

  created() {
    this.onGetBaseItems();
    this.onGetEmployeeDayAttendEditData();
  }

  @Watch("drawerParams")
  @Watch("selectedYear")
  @Watch("selectedMonth")
  onGetEmployeeDayAttendEditData() {
    this.appEnv.isBusy = true;
    this.isEmployeeAttendDayEditDataReady = false;
    apiService
      .getEmployeeAttendDayEntry(
        this.currentEmployee.id,
        this.selectedYear,
        this.selectedMonth,
        this.currentEmployee.salaryFactoryNo,
        this.drawerParams.day.date,
        this.selectedEmpNominationId
      )
      .then((res) => {
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          this.employeeAttendDayEditData = call.callResult.data as Models.EAME_DayDto;
          this.attendSpecialEventsLocal = this.attendSpecialEvents;
          this.isEmployeeAttendDayEditDataReady = true;
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
        this.appEnv.isBusy = false;
      })
      .catch((err) => {
        this.appEnv.isBusy = false;
      });
  }


  onFiterNotSignReasons(val, update, abort) {
    update(() => {
      const needle = val.toLowerCase();
      this.notSignReasonsLocal = this.notSignReasons.filter((v) =>
        v.name.includes(needle)
      );
    });
  }

  onFiterAttendSpecialEvents(val, update, abort) {
    update(() => {
      const needle = val.toString().toLowerCase();
      this.attendSpecialEventsLocal = this.attendSpecialEvents.filter((v) =>
        v.name.includes(needle)
      );
    });
  }

  onGetBaseItems() {
    store.dispatch(
      AppConstants.StoreActions.GetBaseItem,
      AppConstants.BaseItems.MissingEvent
    );
    store.dispatch(
      AppConstants.StoreActions.GetBaseItem,
      AppConstants.BaseItems.NotSingingReason
    );
  }

  onAddPair() {
    let pair = new Models.EAME_PairDto();
    pair.employeeId = this.drawerParams.day.employeeId;
    pair.entryLog = new Models.EmployeeEntryExitLog();
    pair.exitLog = new Models.EmployeeEntryExitLog();
    pair.entryLog.isManualEntry = true;
    pair.entryLog.sourceCode = AppConstants.AttendEntrySource.Portal;
    pair.entryLog.notSingingReasonId = 0;
    pair.missingEventId = 0;
    pair.exitLog.isManualEntry = true;
    pair.exitLog.sourceCode = AppConstants.AttendEntrySource.Portal;
    pair.exitLog.notSingingReasonId = 0;
    pair.missingEventId = 0;
    pair.attendSpecialEventId = 0;
    pair.isFillTeken = false;
    pair.id = -1;
    let lastPair = this.employeeAttendDayEditData.pairs[
      this.employeeAttendDayEditData.pairs.length - 1
    ];
    if (lastPair && this.employeeAttendDayEditData.pairs.length > 0) {
      let pairIndex = this.employeeAttendDayEditData.pairs.indexOf(lastPair);
      pair.key = `${this.employeeAttendDayEditData.id}~${pairIndex + 2}`;
    } else {
      pair.key = `${this.employeeAttendDayEditData.id}~1`;
    }
    this.employeeAttendDayEditData.pairs.push(pair);
  }

  onEntryTimeChanged(e, pair) {
    pair.entryLog.timeText = Models.AppUtils.formatTime(e.target.value);
    this.appEnv.onResetIsFillTeken(this.employeeAttendDayEditData, this.employeeAttendDayEditData.pairs, pair, this.attendSpecialEventsLocal);
  }

  onExitTimeChanged(e, pair) {
    pair.exitLog.timeText = Models.AppUtils.formatTime(e.target.value);
    this.appEnv.onResetIsFillTeken(this.employeeAttendDayEditData, this.employeeAttendDayEditData.pairs, pair, this.attendSpecialEventsLocal);
  }

  onStandByEntryTimeChanged(e) {
    this.employeeAttendDayEditData.standByData.startTimeText = Models.AppUtils.formatTime(e.target.value);
  }

  onStandByExitTimeChanged(e) {
    this.employeeAttendDayEditData.standByData.endTimeText = Models.AppUtils.formatTime(e.target.value);
  }
  onAttendSpecialEventIdChanged(e, pair) {
    this.appEnv.onResetIsFillTeken(this.employeeAttendDayEditData, this.employeeAttendDayEditData.pairs, pair, this.attendSpecialEventsLocal);
  }

  getRedFrameForMonthlyOrHourly(line: Models.EAME_PairDto, isEntry: boolean) {
    let teken = line.stdTime;
    let time = "";

    if (isEntry) {
      time = line.entryLog.timeText;
    } else {
      time = line.exitLog.timeText;
    }

    let recordDate = Date.parse(line.date);
    let todayDate = Date.parse(new Date(new Date().setHours(0, 0, 0, 0)).toISOString());

    if (teken > 0 && todayDate > recordDate) {
      switch (this.currentEmployee.empEmploymentTypeCode) {
        case AppConstants.EmpEmploymentType.Monthly:
          return !time && line.missingEventId == 0 ? "negative" : "";
          break;
        case AppConstants.EmpEmploymentType.Hourly:
          return !time &&
            ((line.entryLog.timeText && !line.exitLog.timeText) ||
              (!line.entryLog.timeText && line.exitLog.timeText)) &&
            line.missingEventId == 0
            ? "negative"
            : "";
          break;
      }
    }
  }

  onSaveEmployeeAttendEditMobile(e) {
    e.preventDefault();

    let hasErrors = this.onCheckSaveRules();
    this.$forceUpdate();
    if (hasErrors) return;

    this.appEnv.isBusy = true;
    apiService
      .saveEmployeeAttendDayEntry(
        this.currentEmployee.id,
        this.selectedYear,
        this.selectedMonth,
        this.currentEmployee.salaryFactoryNo,
        this.employeeAttendDayEditData
      )
      .then((res) => {
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          this.employeeAttendViewData.lines = call.callResult.data.lines;
          this.onCloseEmployeeAttendEditMobileDrawer();
          Utils.Notification.notifyPositive(this.$t("msgs.save").toString(), "thumb_up");
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
        this.appEnv.isBusy = false;
      })
      .catch((err) => {
        this.appEnv.isBusy = false;
      });
  }

  onCheckSaveRules(): boolean {
    let day = this.employeeAttendDayEditData;
    let sbDay = this.employeeAttendDayEditData.standByData;
    sbDay.hasStartTimeError = false;
    sbDay.hasEndTimeError = false;
    let pairsWithData = this.employeeAttendDayEditData.pairs.filter(
      (s) =>
        s.hasNotesError ||
        s.hasEntryNotSingingReasonError ||
        s.hasExitNotSingingReasonError ||
        s.entryLog.timeText ||
        s.exitLog.timeText ||
        s.hasSpecialEventRequiredError
    );
    let attendWithOutRemark = this.appEnv.isAllowed(
      AppConstants.Permissions.AttendWithoutRemark
    );
    let isNotSingingReasonRequired = this.appEnv.isAllowed(
      AppConstants.Permissions.PortalNotSignReasonMandatory
    );
    let notSignReasons = store.getters.baseItems[AppConstants.BaseItems.NotSingingReason];

    if (
      day.hasNotesError ||
      day.hasEntryNotSingingReasonError ||
      day.hasExitNotSingingReasonError ||
      day.entryLog.timeText ||
      day.exitLog.timeText ||
      day.hasSpecialEventRequiredError
    ) {
      this.appEnv.onSetAttendEditNotesFieldError(
        day,
        attendWithOutRemark,
        notSignReasons
      );
      this.appEnv.onSetEntryNotSingingReasonErrorFieldError(
        day,
        isNotSingingReasonRequired
      );
      this.appEnv.onSetAttendSpecialEventFieldError(day);
    }

    pairsWithData.forEach((pair) => {
      this.appEnv.onSetAttendEditNotesFieldError(
        pair,
        attendWithOutRemark,
        notSignReasons
      );
      this.appEnv.onSetEntryNotSingingReasonErrorFieldError(
        pair,
        isNotSingingReasonRequired
      );
      this.appEnv.onSetAttendSpecialEventFieldError(pair);
    });

    let pairsWithErrors = pairsWithData.filter(
      (s) =>
        s.hasNotesError ||
        s.hasEntryNotSingingReasonError ||
        s.hasExitNotSingingReasonError ||
        s.hasSpecialEventRequiredError
    );
    if (!sbDay.startTimeText && sbDay.endTimeText) {
      sbDay.hasStartTimeError = true;
    }
    if (sbDay.startTimeText && !sbDay.endTimeText) {
      sbDay.hasEndTimeError = true;
    }
    if (
      day.hasNotesError ||
      day.hasEntryNotSingingReasonError ||
      day.hasExitNotSingingReasonError ||
      day.hasSpecialEventRequiredError ||
      sbDay.hasStartTimeError ||
      sbDay.hasEndTimeError ||
      (pairsWithErrors && pairsWithErrors.length > 0)
    ) {
      return true;
    }

    return false;
  }

  onCloseEmployeeAttendEditMobileDrawer() {
    store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, false);
    store.commit(AppConstants.StoreMutations.UpdateLeftDrawerComponnent, null);
    store.commit(AppConstants.StoreMutations.UpdateDrawerParams, {});
  }

  getMissingEventName(missingEventId) {
    if (missingEventId > 0) {
      let missingEvent = this.missingEvents.find((s) => s.id == missingEventId);
      if (missingEvent) {
        return missingEvent.name;
      }
    } else {
      return;
    }
  }

  getSpecialEventName(specialEventId) {
    if (specialEventId > 0) {
      let specialEvent = this.attendSpecialEvents.find((s) => s.id == specialEventId);
      if (specialEvent) {
        return specialEvent.name;
      }
    } else {
      return;
    }
  }

  getNotSingingReasonName(notSingingReasonId) {
    if (notSingingReasonId > 0) {
      let notSingingReason = this.notSignReasons.find((s) => s.id == notSingingReasonId);
      if (notSingingReason) {
        return notSingingReason.name;
      }
    } else {
      return;
    }
  }

  public get selectedEmpNominationId(): number {
    return store.getters.selectedEmpNominationId;
  }

  get canEditMonth() {
    return store.getters.canEditMonth;
  }

  get missingEvents() {
    return this.baseItems[AppConstants.BaseItems.MissingEvent];
  }

  get attendSpecialEvents() {
    let t = this.employeeAttendDayEditData.attendSpecialEvents;
    if (!t) {
      return [];
    }
    return this.employeeAttendDayEditData.attendSpecialEvents;
  }

  get notSignReasons() {
    let t = this.baseItems[AppConstants.BaseItems.NotSingingReason];
    if (!t) {
      return [];
    }
    return this.baseItems[AppConstants.BaseItems.NotSingingReason];
  }

  get isPortalLocked() {
    return this.employeeAttendViewData.isPortalLocked;
  }

  get isSaveDisabled() {
    if (this.isPortalLocked || !this.canEditMonth) return true;

    // Allow saving standby data even on all-day event days.
    if (this.employeeAttendDayEditData.isAllDay && this.drawerParams.isStandBy) return false;

    return this.employeeAttendDayEditData.isAllDay;
  }

  set employeeAttendViewData(value) {
    store.commit(AppConstants.StoreMutations.UpdateEmployeeAttendViewData, value);
  }

  get employeeAttendViewData() {
    return store.getters.employeeAttendViewData;
  }

  get drawerParams() {
    return store.getters.drawerParams;
  }

  get selectedYear() {
    return store.getters.selectedYear;
  }

  get selectedMonth() {
    return store.getters.selectedMonth;
  }

  get currentEmployee() {
    return store.getters.currentEmployee;
  }

  get baseItems() {
    return store.getters.baseItems;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
